import type { SearchInfo } from "@app/types/search-types";

import type { MaybePartner } from "@partners/partner.type";

import { CartStandardV2 } from "./cart-standard-v2";

export function createCart(
  search: SearchInfo,
  whitelabel: MaybePartner
): CartStandardV2 {
  return new CartStandardV2(search, whitelabel);
}
